<template>
  <div class="teacher-content-books">
    <!-- <div class="preview-hader-top clearfix">
      <p class="title-file-top">{{docName}}</p>
      <span class="sp-button-fanhui" @click="goFanhui">返回</span>
    </div> -->
    <div
      class="PreviewLeft"
      v-show="ishideen"
      :class="{maxleftwidth:docType==1,caclheightmax:docType!=2 && docType!=6 || diloagslt==true,caclheight:(docType==2||docType==6) && diloagslt==true,mincaclheight:diloagslt==false,urlsourcewidth:docType==7}">
      <div class="bigimg">
        <div v-if="docType==2" v-show="isheight==2" class="img-precol" style="height:100%;text-align: center;overflow: auto;">
          <!-- <viewer :images="imgurl" :options="options" ref="viewers"> -->
           <div style="width:100%;height:100%;overflow: hidden;">
             <viewer :images="imgurl" :options="options" ref="viewers">
              <img class="img-preleft" :src="imgurl"  style="max-width:100%;height:100%" v-show="false" />
             </viewer>
           </div>
          <!-- </viewer> -->
        </div>
        <!-- <iframe v-if="docType==7" style="width:100%;height:100%;" frameborder=0 scrolling=no :src="imgurl"></iframe> -->
        <a :href="imgurl" v-if="docType==7" target="_blank" style="width:100%;height:100%;"></a>
        <iframe
          id="pptiframe"
          v-if="docType==6"
          style="width:100%;height:100%;"
          frameborder="0"
          scrolling="no"
          :src="offeceUrl">
        </iframe>
        <div v-if="docType==2" v-show="isheight==1" class="img-precol" style="width:100%;height:100%">
          <img class="img-preleft" :src="imgurl" style="width:100%;margin-top:5%;" />
        </div>
        <div v-if="docType==1" v-show="isheight==1||isheight==2" style="height:100%;text-align: center;overflow: auto;">
          <!-- 弹性布局修改，地图显示不完全 -->
          <i style="height:100%;display:inline-block;vertical-align: middle;"></i>
          <!-- 弹性布局修改，地图显示不完全 -->
          <viewer :images="images" :options="options" ref="viewer">
            <img v-for="src in images" :src="src" :key="src" v-show="false" />
          </viewer>
        </div>
        <div v-if="docType==3" style="text-align:center;height:100%;">
          <video
            object-fit="cover"
            style="max-width:90%;margin-top: 20px;"
            id="videoShow"
            controls="controls"
            autoplay="autoplay">
            <source :src="imgurl" type="video/mp4" />
          </video>
        </div>
        <object v-if="docType==8" style="height:100%;width:100%;" :data="imgurl"></object>
        <div v-if="docType==4" style="text-align:center;height:100%;">
          <div style="margin-top:20%;">
            <img style="width:60%" src="~assets/images/miscu.gif" alt />
          </div>
          <audio :src="imgurl" controls="controls" ref="audioSourceDom" style="width:60%;"></audio>
        </div>
        <div
          v-if="docType==5"
          style="height:600px;position:relative;"
          class="html-fullScreen-show"
          ref="htmlFullScreenShow">
          <i style="position:absolute;top:-63px;right:36px;font-size:20px;" class="el-icon-rank"></i>
          <iframe :src="htmlShowUrl" frameborder="0" width="100%" height="100%"></iframe>
        </div>
        <iframe
          v-if="docType==9"
          style="width:100%;height:100%;"
          frameborder="0"
          scrolling="no"
          :src="imgurl"
        ></iframe>
      </div>
    </div>
    <!-- <div v-if="(docType==2||docType==6) && type!='xls' && type!='xlsx'"
      class="PreviewRight"
      :class="{bacl:docType==6}"
      v-show="!diloagslt">
      <div class="PreviewRight-top">
        <el-row style="height:100%;" id="box">
          <el-col
            :id="'content'+index"
            :span="19"
            class="imglistcol"
            v-for="(item,index) in pptImages"
            :key="index"
            :class="{nameActive:nameActive==index}"
          >
            <img @click="isimg(item,index)" class="img" :src="item" alt />
          </el-col>
        </el-row>
      </div>
    </div> -->
    <div class="imgblowup">
      <div class="innerimg">

        <!-- <div class="btn_pre">
          <el-button
            type="danger"
            style="width:100%;"
            v-if="(docType==2||docType==6) && bottommenu && type!='xls'&& type!='xlsx'"
            @click="slt()"
          >缩略图</el-button>
        </div> -->
        <!-- <div class="btn_pre">
          <el-button type="danger" style="width:100%;" v-if="docType==1" @click="rotate()">旋转</el-button>
        </div>
        <div class="btn_pre">
          <el-button type="danger" style="width:100%;" v-if="docType==1" @click="fangda()">放大</el-button>
        </div>
        <div class="btn_pre">
          <el-button type="danger" style="width:100%;" v-if="docType==1" @click="suoxiao()">缩小</el-button>
        </div> -->
        <!-- <div class="btn_pre">
          <el-button type="danger" style="width:100%;" @click="back()">关闭</el-button>
        </div> -->
      </div>
    </div>
    <el-row class="dialogimg" v-show="dialogVisible">
      <i @click="handleClose" style="color:white" class="el-icon-close icon-closeimg"></i>
      <el-col class="allimg-col" v-for="(item,index) in pptImages" :key="index">
        <img v-if="item!=''" class="allimg-img" @click="isimg(item,index)" :src="item" alt />
        <img v-if="item==''" class="allimg-img" @click="isimg(item,index)" :src="pptImages[0]" alt />
      </el-col>
    </el-row>
    <el-row class="zzrow" v-show="dialogVisible"></el-row>
    <div class="page-number-center">
      <div class="btn_pre-left"  v-if="(docType==2||docType==6) && bottommenu && type!='xls'&& type!='xlsx'" @click="lastimg()">
        <i class="wl-icon-xiangzuo"></i>
      </div>
      <div class="btn_pre-fd" @click="fangda()" v-if="docType==1">
        +
      </div>
      <h3  v-if="(docType==2||docType==6) && bottommenu && type!='xls'&& type!='xlsx'" class="page-number-count">{{nameActive + 1}}/{{pptImages.length}}</h3>
      <div class="btn_pre-right"  v-if="(docType==2||docType==6) && bottommenu && type!='xls'&& type!='xlsx'" @click="nextimg()">
        <i class="wl-icon-xiangyou1"></i>
      </div>
      <div class="btn_pre-sx" @click="suoxiao()" v-if="docType==1">
        -
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Message } from "element-ui";
export default {
  name: "PreparingCourseware",
  data() {
    return {
      faceTeach: {
        Id: "",
        ClassId: ""
      },
      pptImages: [],
      imgurl: "",
      imgurl: [],
      images: [],
      options: {
        inline: true,
        button: false,
        navbar: false,
        toolbar: false,
        title: false
      },
      nameActive: 0,
      dialogVisible: false,
      changestate: false,
      ishideen: true,
      docType: 0,
      type: 0,
      isheight: 0,
      offeceUrl: "",
      pptpageindex: 1,
      currentPageIndex: 1,
      diloagslt: false,
      faceTeachList: [],
      dialogVisibleFaceTeach: false,
      facePagination: {
        totalCount: 10,
        pageSize: 6,
        pageIndex: 1
      },
      faceTeachId: "",
      classList: [],
      faceClassId: "",
      faceName: "",
      fileSourceId: "",
      route: 0,
      pinchImg: null,
      docName:''
    };
  },
  props: {
    fileList: {
      type: Array,
      defaut: []
    },
    bottommenu: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: String,
      default: ""
    },
    courseId:{
      type: String,
      default:""
    }
  },
  computed: {
    viewer() {
      return this.$refs.viewer && this.$refs.viewer.$viewer;
    },
    // viewers() {
    //   return this.$refs.viewers && this.$refs.viewers.$viewer;
    // }
  },
  created() {
    console.log(this.fileList);
    this.fileSourceId = this.sourceId;
    this.previewImage();
    // this.scrollwidth();
  },

  mounted() {
   //课件的页面事件
    window.addEventListener('message', e =>{
        if(typeof(e.data)=='string'){
          var data=JSON.parse(e.data).payload;
          if(data >= 0){
              this.currentPageIndex = data+1;
              this.nameActive=data;
          }
        }
      });
  },
  methods: {
    pinch(evt) {
      debugger;
      this.pinchImg = document.getElementById("pinchImg");
      Transform(this.pinchImg);
      var initScale = 1;
      this.pinchImg.scaleX = this.pinchImg.scaleY = initScale * evt.zoom;
    },
    pressMove(evt) {
      this.pinchImg = document.getElementById("pinchImg");
      Transform(this.pinchImg);
      this.pinchImg.translateX += evt.deltaX;
      this.pinchImg.translateY += evt.deltaY;
      evt.preventDefault();
    },
    fangda() {
      this.viewer.zoom(1);
      // this.viewers.zoom(1);
    },
    suoxiao() {
      this.viewer.zoom(-1);
      // this.viewers.zoom(-1);
    },
    rotate() {
      this.viewer.rotate(90);
    },
    nextFile() {
      var index = this.fileList.indexOf(this.fileSourceId);
      if (this.fileList.length > index + 1) {
        index += 1;
        this.fileSourceId = this.fileList[index];
        this.pptImages = [];
        this.previewImage();
      }
    },
    lastFile() {
      var index = this.fileList.indexOf(this.fileSourceId);
      if (0 < index) {
        index -= 1;
        this.fileSourceId = this.fileList[index];
        this.pptImages = [];
        this.previewImage();
      }
    },
    
    slt() {
      this.diloagslt = !this.diloagslt;
    },
    back() {
      this.$emit("dialogVisiblePreviewResources", false);
    },
    gotopage(pageindex) {
      var jsonObj = {
        type: 'Goto',
        payload: pageindex
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");
    },
    lastimg() {
      if (this.nameActive > 0 && this.docType != 6) {
        debugger;
        this.nameActive = parseInt(this.nameActive) - 1;
        this.imgurl = this.pptImages[this.nameActive];
        this.images = [this.imgurl];
        this.pptpageindex = this.pptpageindex - 1;
      }
      if (this.docType == 6 && this.currentPageIndex > 1) {
        this.preAnim();
      }
      var content = "#content" + this.nameActive;
      // $(".PreviewRight-top").prop(
      //   "scrollLeft",
      //   $(content).position().left - $(".PreviewRight-top").width() / 2 + 140
      // );
    },
    nextimg() {
      if (this.nameActive < this.pptImages.length - 1 && this.docType != 6) {
        this.nameActive = parseInt(this.nameActive) + 1;
        this.imgurl = this.pptImages[this.nameActive];
        this.images = [this.imgurl];
        this.pptpageindex = this.pptpageindex + 1;
      }
      if (this.docType == 6 && this.currentPageIndex < this.pptImages.length) {
        this.nextAnim();
      }
      var content = "#content" + this.nameActive;
      // $(".PreviewRight-top").prop(
      //   "scrollLeft",
      //   $(content).position().left - $(".PreviewRight-top").width() / 2 + 140
      // );
    },
    preAnim() {
      var jsonObj = {
        type: 'PrevSlide'
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");
      if (this.pptpageindex > 1 && this.docType != 6) {
        debugger;
        this.pptpageindex = this.pptpageindex - 1;
      } else if (this.docType != 6) {
        this.pptpageindex = 1;
      }
    },
    nextAnim() {
      var jsonObj = {
        type:'NextSlide',
      };
      var msg = JSON.stringify(jsonObj);
      document.getElementById("pptiframe").contentWindow.postMessage(msg, "*");
      if (this.pptpageindex < this.pptImages.length && this.docType != 6) {
        ddebugger;
        this.pptpageindex = this.pptpageindex + 1;
      } else if (this.docType != 6) {
        this.pptpageindex = this.pptImages.length;
      }
    },
    exitblowup() {
      this.changestate = false;
      this.ishideen = true;
    },
    onchangestate() {
      this.changestate = true;
      this.ishideen = false;
    },
    onchangelook() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleFaceTeach = false;
    },
    isimg(val, index) {
      if (this.docType == 6) {
        this.gotopage(index + 1);
        this.currentPageIndex = index + 1;
        this.nameActive = index;
      } else {
        this.nameActive = index;
        this.pptpageindex = index + 1;
        this.imgurl = val;
        this.images = [this.imgurl];
      }
      var content = "#content" + this.nameActive;
      // $(".PreviewRight-top").prop(
      //   "scrollLeft",
      //   $(content).position().left - $(".PreviewRight-top").width() / 2 + 140
      // );
      this.dialogVisible = false;
    },
    getPictureList() {
      var img = new Image();
      var that = this;
      this.$http
        .post("/api/XOrg/TextBookSourceInfo/getPictureList", {
          id: this.fileSourceId
        })
        // .then(rst => {});
        // getPictureList(this.fileSourceId)
        .then(res => {
          if (!res.list) {
            // this.$message("稍等文件未转换完成！");
          } else {
            for (let i = 0; i < res.list.length; i++) {
              this.pptImages.push(res.list[i].picpath);
            }
            this.imgurl = this.pptImages[this.nameActive];
            this.images = [this.imgurl];
            img.src = that.imgurl;
            img.onload = function() {
              if (img.width > img.height) {
                that.isheight = 1;
              } else {
                that.isheight = 2;
              }
            };
          }
        });
    },
    previewImage() {
      var img = new Image();
      var that = this;
      this.$http.post("/api/XOrg/TextBookSourceInfo/getNewCourseWareInfo", {
          courseWareId: this.fileSourceId
        }).then(rst => {
          this.docName = rst.docName;
          if (rst.status === -1) {
            // Message.warning("文件转换失败不能预览");
          } else if (rst.status === -2) {
            // Message.warning("文件正在转换请稍后预览");
          } else if (rst.status === 1) {
            this.docType = rst.docType;
            this.type = rst.type;
            if (rst.docType === 2) {
              this.getPictureList();
            } else if (rst.docType === 6) {

              this.getPictureList();
              if (this.type == "xls" || this.type == "xlsx") {
                this.diloagslt = true;
              }
              this.offeceUrl = rst.offecedocurl;
            } else {
              this.pptImages[0] = rst.docPriviewUrl;
              this.imgurl = rst.docPriviewUrl;
              this.images = [this.imgurl];
              img.src = rst.docPriviewUrl;
              img.onload = function() {
                if (img.width > img.height) {
                  that.isheight = 1;
                } else {
                  that.isheight = 2;
                }
              };
            }
          }
        });
    },
    goFanhui(){
      debugger;
      this.$router.push({
        name: 'teachingDetails',
         params: {
          bookId: this.courseId
        }
      })
    },
  }
};
</script>
<style lang="scss">
.teacher-content-books {
  margin: 0 auto;
  overflow: hidden;
  height: 100%;
  width: 100% !important;
  position: relative;
  .preview-hader-top{
    margin-bottom: 20px;
    height: 42px;
    padding: 0px 20px;
    line-height: 42px;
    background: #5c9eff;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    .title-file-top{
      float: left;
      width: 80%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .sp-button-fanhui{
      float: right;
      cursor: pointer;
    }
  }
  .urlsourcewidth {
    width: 100%;
  }

  .pptwidth {
    width: 80%;
  }
  .pptpageindexcolor {
    background-color: #409eff;
  }
  .img_one {
    max-width: 88%;
    vertical-align: middle;
  }
  .img_two {
    max-height: 100%;
    vertical-align: middle;
  }
  .back_btn {
    background: #ff0000;
  }
  .btn_pre-left {
    position: absolute;
    // background: rgba(255, 154, 160,0.5);
    background: #5c9eff;
    color: #fff;
    font-size: 22px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 100%;
    left: 40%;
    cursor: pointer;
  }
  .btn_pre-right {
    position: absolute;
    // background: rgba(255, 154, 160,0.5);
    background: #5c9eff;
    color: #fff;
    font-size: 22px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 100%;
    right: 40%;
    top: 0;
    cursor: pointer;
  }
  .btn_pre-fd {
    position: absolute;
    // background: rgba(255, 154, 160,0.5);
    background: #5c9eff;
    color: #fff;
    font-size: 22px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 100%;
    right: 46%;
    top: 0;
    cursor: pointer;
  }
  .btn_pre-sx {
    position: absolute;
    // background: rgba(255, 154, 160,0.5);
    background: #5c9eff;
    color: #fff;
    font-size: 22px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 100%;
    left: 46%;
    top: 0;
    cursor: pointer;
  }
  .btn_pre-sx:hover{
    // background: rgba(255, 154, 160,0.8);
    background: #5c9eff;
  }
  .btn_pre-fd:hover{
    // background: rgba(255, 154, 160,0.8);
    background: #5c9eff;
  }
  .btn_pre-right:hover{
    // background: rgba(255, 154, 160,0.8);
    background: #5c9eff;
  }
  .btn_pre-left:hover{
    // background: rgba(255, 154, 160,0.8);
    background: #5c9eff;
  }
  margin: 0 auto;
  // background-color: #304b4b;
  overflow: hidden;
  height: 100%;
  width: 90%;
  .floatleft {
    float: left;
  }
  .maxleftwidth {
    width: 100%;
  }
  .minleftwidth {
    width: 80%;
  }
  .nameActive {
    background-color: #409eff;
  }
  .caclheight {
    height: calc(100% - 185px);
  }
  .mincaclheight {
    height: calc(100% - 140px);
  }
  .caclheightmax {
    height: 83%;
  }
  .PreviewLeft {
    .bigimg {
      height: 80%;
      .img-precol {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .img-preleft {
        margin: 0 auto;
      }
      height: 100%;
    }
  }
  .PreviewRight {
    width: 100%;
    height: 150px;
    position: relative;
    bottom: 20px;
    // float: right;
    // border:2px solid #0F5858;
    .btn-imgpre {
      margin-top: 20px;
    }
    .PreviewRight-top {
      .imglistcol {
        // float:left;
        float: none;
        display: inline-block;
        border-radius: 5%;
        height: 100%;
        width: 140px;
        border: 1px solid grey;
        margin-left: 2%;
        padding: 5px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      height: 97%;
      width: 90%;
      margin-bottom: 20px;
    }
    .PreviewRight-bottom {
      position: fixed;
      right: 30px;
      bottom: 30px;
      width: 100%;
      text-align: right;
    }
  }
  .dialogimg {
    .allimg-col {
      .allimg-img {
        width: 100%;
        height: 100%;
      }
      float: left;
      width: 210px;
      height: 150px;
      margin: 10px;
    }
    .zzrow {
      width: 150%;
      height: 100%;
      position: fixed;
      top: 0;
      left: -100px;
      background-color: black;
      opacity: 0.9;
      z-index: 300000000;
    }
    .imgblowup {
      .blowupimg {
        .innerimg {
          width: 100%;
          height: 70px;
          z-index: 200000001;
          position: fixed;
          bottom: 0px;
          margin-left: 40%;
        }
        width: 100%;
        height: 100%;
      }
      position: relative;
      top: 0px;
      width: 100%;
      background-color: grey;
      z-index: 200000000;
    }
    .icon-closeimg {
      size: 26px;
      position: fixed;
      top: 20px;
      right: 20px;
      font-size: 35px;
      cursor: pointer;
      font-weight: bolder;
    }
    z-index: 200000001;
    overflow: auto;
    cursor: pointer;
    position: fixed;
    top: 15%;
    left: 25%;
    height: 600px;
    width: 960px;
  }
  .page-number-center{
    position: relative;
    text-align: center;
    width: 100%;
    line-height: 40px;
    height: 40px;
    .page-number-count{

    }
  }
  .viewer-backdrop{
    background-color: #fff;
  }
}
</style>